import React, { useState } from "react";

function FileUpload({onFileChanged}) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length > 1) {
      setErrorMessage("Nu se pot incarca mai mult de o imagine.");
      return;
    }

    setSelectedFiles(files);
    setErrorMessage("");
    onFileChanged(files[0]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);

    const files = Array.from(event.dataTransfer.files);

    if (selectedFiles.length + files.length > 1) {
      setErrorMessage("Nu se pot incarca mai mult de o imagine.");
      return;
    }

    setSelectedFiles((prev) => [...prev, ...files.slice(0, 3 - prev.length)]);
    setErrorMessage("");
  };

  return (
    <div className="flex flex-col items-center h-full bg-[#242424] rounded-lg">
      <div
        className={`border-2 ${
          dragActive ? "border-[#009BFF]" : "border-[#696969]"
        } border-dashed p-4 w-full h-30 flex flex-col items-center justify-center text-center bg-[#242424] rounded-t-lg`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <p className="text-gray-500">Adauga imagini</p>
        <p className="text-gray-500">(.png / .jpeg / .jpg / .heic)</p>

        <label
          style={{ color: "#009BFF" }}
          className="cursor-pointer hover:underline mt-2 select-none"
          htmlFor="fileInput"
        >
          Încarcă
        </label>


        <input
          id="fileInput"
          type="file"
          accept="image/png, image/jpeg,  image/jpg,  image/heic" //heic images may need conversion
          multiple
          className="hidden"
          onChange={handleFileChange}
        />
      </div>

      <div className="mt-4 w-full h-32 overflow-y-auto bg-[#242424] border border-[#696969] p-2 rounded-b-lg ">
        {errorMessage && (
          <p className="text-red-500 text-sm mb-2">{errorMessage}</p>
        )}
        {selectedFiles.length === 0 ? (
          <p className="text-[#a7a7a7] text-sm">Nu au fost incarcate imagini.</p>
        ) : (
          <ul className="text-[#009BFF] text-sm space-y-2">
            {selectedFiles.map((file, index) => (
              <li key={index} className="truncate">
                {file.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default FileUpload;
